import React from "react";

const AddressLink = ({ address, websites }) => {
  if (!websites || !websites.length) {
    return <>{address}</>;
  }

  const mapsObject = websites.filter(
    (site) => site.type === "GoogleMapsLink"
  )[0];

  if (!mapsObject || !mapsObject.url) {
    return <>{address}</>;
  }

  return (
    <a href={mapsObject.url} target="_new">
      {address}
    </a>
  );
};

export default AddressLink;
